// Pure helpers for the timesheets table. Plain JS so node --test can import them.

/**
 * The union of the rows' keys, in the order each key first appears.
 * @param {ReadonlyArray<Record<string, unknown>>} rows
 * @returns {string[]}
 */
export function timesheetColumns(rows) {
  const seen = new Set();
  for (const row of rows) {
    for (const key of Object.keys(row)) seen.add(key);
  }
  return [...seen];
}

/**
 * The text of one cell. Empty for null and undefined; objects as JSON.
 * @param {unknown} value
 * @returns {string}
 */
export function timesheetCell(value) {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}
